const Brands = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">Brands</h1>
      </div>

      <div className="sm:flex grid max-w-[70rem] gap-8 sm:gap-0 mx-auto flex-col md:flex-row py-[7rem] px-[8rem]  justify-around">
        <div className="">
          <a
            target="_blank"
            href="https://sentimentsexpress.com/"
            rel="noopener noreferrer"
          >
            <img
              src="/Home/sentiments.svg"
              alt="sentiments"
              className="w-[8rem]"
            />
          </a>
        </div>
        <div className="mt">
          <a
            target="_blank"
            href="https://www.studiobytcs.com/"
            rel="noopener noreferrer"
          >
            <img src="/Home/studio.svg" alt="studio" className="w-[8rem]" />
          </a>
        </div>
        <div className="">
          <a
            target="_blank"
            href="https://octara.com/"
            rel="noopener noreferrer"
          >
            <img src="/Home/octara.svg" alt="octara" className="w-[8rem]" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Brands;
